<template>
	<div class="position-relative">
		<!-- <img :class="{ 'overlay-items' : Overlay }" class="gallery-item" :src="image" loading="lazy"/> -->
		<div :class="{ 'overlay-items' : Overlay }" class="gallery-item" :style="style" loading="lazy"></div>
		<h1 class="image-title" v-if="title && display_title">{{ title }}</h1>
		<span v-if="Overlay" class="hand-icon hand-left animate__animated animate__infinite animate__pulsse"></span>
		<h1 v-if="Overlay" class="overlay-text"><span v-html="t('gallery_text.enlarge_image')"></span></h1>
	</div>
</template>

<script>
import { useI18n } from "vue-i18n";

export default {
	name: "GalleryItem",
	props: {
		title: String,
		image: String,
		display_title: Boolean,
		Overlay: Boolean,
	},
	computed: {
		style() {
			return `background-image: url('${this.image}')`;
		}
	},
	setup() {
		const { t, te, tm } = useI18n();

		return { t, te, tm };
	},
};
</script>

<style scoped>

.overlay-items {
	position: relative;
	z-index: var(--global-z-index-overlay-items);
	transform: scale(1);
	animation: pulse-gallery-item 2.5s infinite linear;
	box-shadow: 0 0 10px 5px #fff;
}

@keyframes pulse-gallery-item {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.01);
    }
    100% {
        transform: scale(1);
    }
}

.hand-icon {
	position: relative;
	z-index: var(--global-z-index-overlay-info);
	background-image: url("~@/assets/img/icons/touch-me.svg");
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	height: 150px;
	width: 100px;
}

.overlay-text {
	position: absolute;
	line-height: 1;
	left: 0;
	right: 0;
	bottom: -110px;
	text-align: center;
	color: #fff;
	z-index: var(--global-z-index-overlay-info);
}

.image-title {
	text-align: center;
	color: #fff;
	font-size: 30px;
	margin-top: 20px;
}

.hand-left {
    position: absolute;
    left: 150px;
    bottom: 20px;
}

.gallery-item {
	height: 274px;
	width: 500px;
    background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat;
}
</style>